module.exports = __webpack_public_path__ + "img/大橡科技.f6610337.png";